import i18n from 'i18next';

export const getValidationMessage = (params?: any) => ({
    mandatoryError: i18n.t('validation.mandatoryField'),
    phoneError: i18n.t('onboardingFlow.personalPage.validationPhoneNumber'),
    alphanumericError: i18n.t('onboardingFlow.personalPage.validationAlphanumeric'),
    lengthError: i18n.t('onboardingFlow.personalPage.validateInputLength', { length: params?.length }),
});
